import dayjs from "dayjs";
import lodashGet from "lodash/get";
import lodashCloneDeep from "lodash/cloneDeep";

import { httpGet } from "@/services/api.service";
import { ENDPOINT_SCRIBE } from "@/common/constants/api";
import { formatFeatures } from "@/services/media/news.service";
import { isFeatureUnlocked } from "@/common/featureLock.js";

export { _getScribeInfo as getScribeInfo };

function scribeToNewsFeature(doc) {
  let res = {
    type: "Feature",
    properties: doc,
  };

  if (!isFeatureUnlocked("scribe-flattened")) {
    return res;
  }

  if (doc.source_url) {
    if (!res.properties.src) {
      res.properties.src = {};
    }
    res.properties.src.url = doc.source_url;
  }

  if (doc.title) {
    if (!res.properties.newspaper) {
      res.properties.newspaper = {};
    }
    res.properties.newspaper.title = doc.title;
  }

  return res;
}

const _getScribeInfo = async (params) => {
  let ret = {
    params: lodashCloneDeep(params),
    data: null,
  };
  try {
    if (!params.locationCode) {
      console.warn(
        "Issue getting scribe info in scribe.service.js. No locationCode set."
      );
      return false;
    }
    if (!params.locationType) {
      console.warn(
        "Issue getting scribe info in scribe.service.js. No locationType set."
      );
      return false;
    }
    if (!params.score) {
      console.warn(
        "Issue getting scribe info in scribe.service.js. No score set."
      );
      return false;
    }

    let query = `score=${params.score}`;
    if (params.date) {
      // API expects date formatted like %Y-%m-%dT%H:%M:%S
      query += `&date=${dayjs(params.date).format("YYYY-M-DTH:m:s")}`;
    }

    const endpoint = `${ENDPOINT_SCRIBE}/${params.locationCode}/${params.locationType}?${query}`;

    const RESULT = await httpGet({ url: encodeURI(endpoint) });
    const { data } = JSON.parse(RESULT);

    if (lodashGet(data, "narrative")) {
      if (lodashGet(data, "narrative.hotspots.events")) {
        data.narrative.hotspots.events = data.narrative.hotspots.events.map(
          (item) => {
            return scribeToNewsFeature(item);
          }
        );
        formatFeatures(data.narrative.hotspots.events);
      }
      if (lodashGet(data, "narrative.top_events.events")) {
        data.narrative.top_events.events = data.narrative.top_events.events.map(
          (item) => {
            return scribeToNewsFeature(item);
          }
        );
        formatFeatures(data.narrative.top_events.events);
      }
      if (lodashGet(data, "narrative.explanation.events")) {
        data.narrative.explanation.events = data.narrative.explanation.events.map(
          (item) => {
            return scribeToNewsFeature(item);
          }
        );
        formatFeatures(data.narrative.explanation.events);
      }
      ret["data"] = data.narrative;
      return ret;
    }

    console.error(
      "Issue getting scribe info in scribe.service.js. No data.narrative found."
    );
    return null;
  } catch (error) {
    console.error(
      "Issue getting scribe info in scribe.service.js",
      JSON.stringify(error)
    );
    return null;
  }
};
